/**
 * Where the window stops being covered by what sticks over the Insights page (P89, D220 of
 * documentation/pr-plans/insights-simplify-plan.md): the Insights header's bottom, then, in the page's order, the bottom
 * of each bar marked data-insights-sticks while it sticks right under what covers above it. The Group and sort board's
 * head is one (boxes.blade.php); a bar that sticks over the page joins by carrying the attribute.
 *
 * Whatever is placed against the window's top measures from here, not from 0: a chip's ⋯ opened upward from the window's
 * top edge and slid under the header (z-[46]) at z-40 (Ali, 23 Oct). The header's own bottom, never its height
 * (--insights-header-height): the page scrolls under the app's top bar, so the header sticks that bar's height down the
 * window, and its height alone left a menu's first items under it. A marked bar scrolled lower is part of the page, not
 * over it, and one not drawn measures nothing.
 */
const HEADER = "[data-insights-header]";
const STICKS = "[data-insights-sticks]";

export function coveredTop() {
    let covered = document.querySelector(HEADER)?.getBoundingClientRect().bottom ?? 0;

    for (const bar of document.querySelectorAll(STICKS)) {
        const at = bar.getBoundingClientRect();

        // A pixel's slack: a bar sticking at a fractional top reads a hair below the edge it sticks to.
        if (at.top <= covered + 1 && at.bottom > covered) {
            covered = at.bottom;
        }
    }

    return covered;
}
